import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

export interface Request {
	ingredient: string[];
	type: 'id' | 'name';
	source: string[];
	cultureCode: string;
	isCatStrict: boolean;
	pageSize: number;
	pageIndex: number;
}

export interface Response {
	data: ResponseData;
}

const ProductSchema = z.object({
	productId: z.string(),
	category: z.string(),
	currency: z.string(),
	description: z.string().nullable(),
	externalId: z.string(),
	externalUrl: z.string(),
	imageUrl: z.string(),
	name: z.string(),
	nutrients: z.record(z.number().nullable()),
	parentCategory: z.string().nullable(),
	price: z.number(),
	type: z.string(),
	volume: z.number().nullable(),
	weight: z.number(),
});

const ResponseDataSchema = z.record(z.record(z.array(ProductSchema)));
const validator = createValidator(ResponseDataSchema);

export type ResponseData = z.infer<typeof ResponseDataSchema>;
export type Product = z.infer<typeof ProductSchema>;

export async function callApi(request: Request): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.AI}/match/product/`;
	return (await axios.post(url, request).toOptionalFiltered(validator)).map((x) => x.data);
}
